import React from "react"
import FormButton from "../button/FormButton"
import { navigate } from "gatsby"
import { FormControlLabel } from "../section"
import HoneypotField from "../HoneypotField"
import { HONEYPOT_FIELD, validateLead, hasErrors } from "../../utils/leadValidation"
import {
  submitLead,
  captureAttribution,
  getAttributionPayload,
  pushLeadConversion,
  GENERIC_ERROR,
} from "../../utils/submitLead"

class RequestForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      first_name: "",
      email: "",
      mobile_no: "",
      zip: "",
      comment: "",
      [HONEYPOT_FIELD]: "",
      errors: {},
      formError: "",
      submitting: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    captureAttribution()
  }

  handleChange(event) {
    const { id, value } = event.target
    this.setState(prevState => ({
      [id]: value,
      // Clear a field's error as soon as the visitor edits it.
      errors: { ...prevState.errors, [id]: "" },
    }))
  }

  async handleSubmit(event) {
    event.preventDefault()
    if (this.state.submitting) return

    const fields = {
      first_name: this.state.first_name,
      email: this.state.email,
      mobile_no: this.state.mobile_no,
      zip: this.state.zip,
      comment: this.state.comment,
    }

    const errors = validateLead(fields)
    if (hasErrors(errors)) {
      this.setState({ errors, formError: "" })
      return
    }

    const { location } = this.props

    const data = {
      source: location.origin,
      form: "Request Form",
      page: window.location.href,
      first_name: this.state.first_name,
      email: this.state.email,
      mobile_no: this.state.mobile_no,
      comment: this.state.comment,
      ...getAttributionPayload(),
      [HONEYPOT_FIELD]: this.state[HONEYPOT_FIELD],
    }

    this.setState({ submitting: true, formError: "", errors: {} })

    try {
      await submitLead(data)

      // Fires only once the server confirmed the CRM accepted the lead.
      pushLeadConversion({
        email: this.state.email,
        phone: this.state.mobile_no,
      })

      this.setState({
        first_name: "",
        email: "",
        mobile_no: "",
        comment: "",
        submitting: false,
      })
      navigate("/thanks")
    } catch (error) {
      this.setState({
        submitting: false,
        errors: error.fieldErrors || {},
        formError: error.message || GENERIC_ERROR,
      })
    }
  }

  render() {
    const { errors, formError, submitting } = this.state
    return (
      <form id="rightform" onSubmit={this.handleSubmit} noValidate>
        <div className="form-group-bordered">
          <input
            type="text"
            id="first_name"
            className="form-control"
            value={this.state.first_name}
            onChange={this.handleChange}
            required
          />
          <FormControlLabel
            className={
              this.state.first_name !== ""
                ? "control-label active"
                : "control-label"
            }
          >
            Name
          </FormControlLabel>
          {errors.first_name && (
            <span className="form-error">{errors.first_name}</span>
          )}
        </div>
        <div className="form-group-bordered">
          <input
            type="email"
            id="email"
            className="form-control"
            value={this.state.email}
            onChange={this.handleChange}
            required
          />
          <FormControlLabel
            className={
              this.state.email !== "" ? "control-label active" : "control-label"
            }
          >
            Email
          </FormControlLabel>
          {errors.email && <span className="form-error">{errors.email}</span>}
        </div>
        <div className="form-group-bordered">
          <input
            type="tel"
            id="mobile_no"
            className="form-control"
            value={this.state.mobile_no}
            onChange={this.handleChange}
            required
          />
          <FormControlLabel
            className={
              this.state.mobile_no !== ""
                ? "control-label active"
                : "control-label"
            }
          >
            Phone Number
          </FormControlLabel>
          {errors.mobile_no && (
            <span className="form-error">{errors.mobile_no}</span>
          )}
        </div>
        <div className="form-group-bordered">
          <input
            type="text"
            id="zip"
            className="form-control"
            value={this.state.zip}
            onChange={this.handleChange}
            required
          />
          <FormControlLabel
            className={
              this.state.zip !== "" ? "control-label active" : "control-label"
            }
          >
            Zip Code
          </FormControlLabel>
          {errors.zip && <span className="form-error">{errors.zip}</span>}
        </div>
        <div className="form-group-bordered full-row">
          <textarea
            id="comment"
            className="form-control"
            value={this.state.comment}
            onChange={this.handleChange}
            required
          />
          <FormControlLabel
            className={
              this.state.comment !== ""
                ? "control-label active"
                : "control-label"
            }
          >
            Ask Your Query
          </FormControlLabel>
          {errors.comment && (
            <span className="form-error">{errors.comment}</span>
          )}
        </div>
        <HoneypotField
          value={this.state[HONEYPOT_FIELD]}
          onChange={this.handleChange}
        />
        {formError && <div className="form-error form-error-summary">{formError}</div>}
        <div className="form-action">
          <FormButton text={submitting ? "Submitting..." : "Submit"} />
        </div>
      </form>
    )
  }
}
export default RequestForm
